var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faChevronDown, faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from '@mui/material';
var RowLabelRoot = styled('span', {
    shouldForwardProp: function (prop) { return prop !== 'expandable' && prop !== 'bold'; },
})(function (_a) {
    var expandable = _a.expandable, bold = _a.bold;
    return ({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        fontWeight: bold ? 'bold' : undefined,
        cursor: expandable ? 'pointer' : 'default',
    });
});
var ToggleIcon = styled('span')({
    position: 'absolute',
    top: '5px',
    left: '-1.125rem',
    display: 'inline-flex',
    alignItems: 'center',
});
var ChevronIcon = styled(FontAwesomeIcon)({
    fontSize: '0.75rem',
});
export var ExpandableRowLabel = function (_a) {
    var expanded = _a.expanded, onToggle = _a.onToggle, children = _a.children, bold = _a.bold, _b = _a.showIcon, showIcon = _b === void 0 ? true : _b;
    var isExpandable = !!onToggle;
    return (_jsxs(RowLabelRoot, __assign({ expandable: isExpandable, bold: bold, onClick: onToggle, "data-dd-action-name": isExpandable ? 'Toggle row' : undefined }, { children: [isExpandable && showIcon && (_jsx(ToggleIcon, __assign({ "data-testid": "report-row-toggle-icon" }, { children: _jsx(ChevronIcon, { icon: expanded ? faChevronDown : faChevronRight, fixedWidth: true }) }))), children] })));
};
